
import { useStore } from '@/store'
import { computed, defineComponent, inject, onUnmounted, ref, watch } from 'vue'
import * as RenderingConstants from '@/constants/rendering-constants'
import RenderingPathService from '@/services/rendering/rendering-path.service'
import bodySettings from '@/settings/body-settings.json'
import threadSettings from '@/settings/thread-settings.json'
import frontSettings from '@/settings/front-settings.json'
import SentrySingleton from '@/singletons/sentry-singleton'

export default defineComponent({
  name: 'RenderingRandselFront',
  props: {
    cameraPos: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const store = useStore()
    const emitter: any = inject('emitter')
    const configBodyId = computed(() => store.getters.configBodyId)
    const configThreadId = computed(() => store.getters.configThreadId)
    const configFrontId = computed(() => store.getters.configFrontId)
    let imagePath = ref('')
    let renderPathService = new RenderingPathService()

    emitter.on('updateConfig', updateRendering)

    // prettier-ignore
    watch(() => configBodyId.value, (_) => { updateRendering() })
    // prettier-ignore
    watch(() => configThreadId.value, (_) => { updateRendering() })
    // prettier-ignore
    watch(() => configFrontId.value, (_) => { updateRendering() })

    function updateRendering() {
      try {
        const bodyId = renderPathService.formatConfig(configBodyId.value, bodySettings.fullorderColors)
        const threadId = renderPathService.formatConfig(configThreadId.value, threadSettings.threadColors)
        const frontId = renderPathService.formatConfig(configFrontId.value, frontSettings.futaShapeTextures)
        setRendering(bodyId, threadId, frontId)
      } catch (err) {
        SentrySingleton.instance.captureException(err)
      }
    }

    function setRendering(bodyId: string | null, threadId: string | null, frontId: string | null) {
      if (!bodyId || !threadId || !frontId) {
        if (!bodyId) {
          console.error('cannot find body id for RenderingRandselFront')
        }
        imagePath.value = ''
        return
      }

      const camPath = 'cam' + (props.cameraPos + 1) + '/'
      const optionPath = 'front/' + bodyId + '/' + threadId + '/' + frontId + '.png'
      const path = RenderingConstants.path + camPath + optionPath
      imagePath.value = path
    }

    onUnmounted(() => {
      emitter.off('updateConfig', updateRendering)
    })
    
    return {
      imagePath
    }
  }
})
